<template>
  <a-empty
    :image="simpleImage"
    class="empty-chart"
  />
</template>

<script>
import { defineComponent } from 'vue'

import { Empty } from 'ant-design-vue'

export default defineComponent({
  name: 'EmptyChart',
  setup () {
    return {
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE
    }
  }
})
</script>
